import React from "react";
import { IconProps } from "../icon";

export const Expand_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 21L21 3M3 21h6m-6 0v-6M21 3h-6m6 0v6"
    />
  </svg>
);
